var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.row.IsIgnored)?_c('b-badge',{attrs:{"variant":"dark"}},[_vm._v("Yasaklı Değil")]):_c('b-badge',{attrs:{"variant":"danger"}},[_vm._v("Yasaklı")])}
var staticRenderFns = []

export { render, staticRenderFns }